import React from "react";
import Img from "../image/geo_acad.png"

const FooterDashboard = () =>{
    const handlePolicyDisplay = () =>{
        const formcontainer = document.querySelector(".dash_add_course_cover.policy")
        formcontainer.style.display = "flex"
    }
    const clearLocalStorage = () => {
        localStorage.removeItem('accessToken');
        localStorage.removeItem('user');
        // Remove other relevant items
        window.location.href = '/';
      };
      const contactdirect = () =>{
        const storedUser = localStorage.getItem('user');
        const user = JSON.parse(storedUser);
        if(user.role === "tutor"){
            window.location.href = '/tutor_dash_contact'
        }else if (user.role === "student") {
            window.location.href = '/dash_contact'
        }
        else{
            window.location.href = '/login'
        }
      }
    return(
        <footer className="dash_footer">
            <section className="footer">
            <button onClick={handlePolicyDisplay}>Privacy & Policy</button>
            <button onClick={contactdirect}>Contact</button>
            <button onClick={clearLocalStorage}>Sign Out</button>
            </section>
          <img src={Img} alt="academi" className="logo"/><p> © 2025 Geoinfotech - Created By <a href="https://staff.geoinfotech.ng/" target="_blank" rel="noreferrer" style={{textDecoration: "none", color : "rgb(20, 115, 197)"}}>Geoinfotech Team</a></p>
          </footer>
    )
}
export default FooterDashboard